import { render } from "./content-carousel.vue?vue&type=template&id=40457039"
import script from "./content-carousel.vue?vue&type=script&lang=js"
export * from "./content-carousel.vue?vue&type=script&lang=js"

import "./content-carousel.vue?vue&type=style&index=0&id=40457039&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__